import { render, staticRenderFns } from "./AssignmentsView.vue?vue&type=template&id=3de0b710&scoped=true"
import script from "./AssignmentsView.vue?vue&type=script&lang=js"
export * from "./AssignmentsView.vue?vue&type=script&lang=js"
import style0 from "./AssignmentsView.vue?vue&type=style&index=0&id=3de0b710&prod&scoped=true&lang=css"
import style1 from "./AssignmentsView.vue?vue&type=style&index=1&id=3de0b710&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de0b710",
  null
  
)

export default component.exports